function EventPerson(method, view, event_id, event_person_id) {
    this.method = method;
    this.url = '/events/' + event_id + '/event_persons/';

    if (event_person_id !== undefined) {
        this.url += event_person_id;
    }
    if (view === 'event') {
        this.datatable = $('#event-persons-datatable').dataTable();
    }
    this.edit_modal = $('#generic-edit-modal');
}

EventPerson.prototype.ajax_call = function(params) {
    var self = this;
    var data;
    if (params !== undefined) data = params;
    $.ajax({
        url         : self.url,
        type        : self.method,
        dataType    : 'json',
        data        : data,
        success     : function(data) {
            if (data.notice) {
                showNotification(data.notice);
                if (data.warn) showNotification(data.warn, 'warning');
                if (self.method !== 'DELETE') self.edit_modal.modal('hide');
                self.datatable.fnDraw(false);
            } else if (data.error) {
                showNotification(data.error, 'danger');
                if (self.method !== 'DELETE') $('#submit').prop('disabled',false);
            }
        },
        error : function (request, status, error) {
            showNotification(request.responseText, 'danger', 'Error in ajax call!');
        }
    });
};

global.load_event_person_edit_form = function (element, event, redirect_code, header) {
    event.preventDefault();
    var target_url = $(element).attr('href');
    if (target_url.length) {
        $('#generic-edit-modal .modal-header h3').text(header);
        $('#generic-edit-modal').modal('show');
        $.ajax({
            url         : target_url,
            data        : {
                redirect_to_view : redirect_code
            },
            success     : function(data) {
                if (data.length) {
                    $('#generic-edit-modal .modal-container').html(data);
                    init_person_selector(false, true);
                    $(".selectpicker").selectpicker();
                }
            }
        });
    }
}

window.delete_event_person = function(params) {
    if (params.length == 2) {
        var event_id = params[0];
        var event_person_id = params[1];
        var event_person = new EventPerson('DELETE', 'event', event_id, event_person_id);
        event_person.ajax_call();
    }
}

$(document).on('submit', '.event_person_form', function(event) {
    event.preventDefault();
    var _this = $(this);
    var view = _this.data('view');
    var event_id = _this.data('event-id');
    var event_person_id = _this.data('id');
    var ajax_method = 'POST';
    if (event_person_id !== undefined) ajax_method = 'PUT';

    var event_person = new EventPerson(ajax_method, view, event_id, event_person_id);
    event_person.ajax_call(_this.serialize());
});

var FEE_TYPE_PAYMENT        = 1;
var FEE_TYPE_EQUAL_SHARE    = 2;
var FEE_TYPE_FIXED_SHARE    = 3;
var FEE_TYPE_NO_FEE         = 4;

$(document).on('change', '#event_person_fee_type_id', function() {
    var fee_type = $(this).find(":selected");
    if (fee_type.val() == FEE_TYPE_PAYMENT) {
        $('.event_person_default_payment').removeClass('stashed');
        $('.event_person_share_percent').addClass('stashed');
        $('.event_person_total_compensation').removeClass('stashed');
    } else if (fee_type.val() == FEE_TYPE_FIXED_SHARE) {
        $('.event_person_default_payment').addClass('stashed');
        $('.event_person_share_percent').removeClass('stashed');
        $('.event_person_total_compensation').addClass('stashed');
    } else {
        $('.event_person_default_payment').addClass('stashed');
        $('.event_person_share_percent').addClass('stashed');
        $('.event_person_total_compensation').addClass('stashed');
    }
    if (fee_type.val() == FEE_TYPE_NO_FEE) {
        $('.event_person_payment_info').addClass('stashed');
        $('.event_person_will_invoice').addClass('stashed');
    } else {
        $('.event_person_payment_info').removeClass('stashed');
        $('.event_person_will_invoice').removeClass('stashed');
    }
});
